<kendo-dialog-titlebar>
    {{'admin-center.user.selectRestrictionToAssign' | translate}}
</kendo-dialog-titlebar>

<form [formGroup]="assignRestrictionForm">

    <list-combo-select-ctrl [caption]="'admin-center.user.restriction'" [settings]="{fxFill:true}"
        [formControlName]="'restrictionId'" [textField]="'description'" [valueField]="'id'"
        [valuesList$]="restrictionsList$"></list-combo-select-ctrl>

</form>

<kendo-dialog-actions>
    <button type="button" kendoButton (click)="confirm()" [primary]="true">{{'global.confirm' | translate}}</button>
</kendo-dialog-actions>
